
FindLink();

var modalClick = false;

function ToggleModal() {
  if(!document.getElementById("shop-modal").classList.contains('display-disabled')) {
    document.getElementById("shop-modal").classList.remove('display-enabled');
    document.getElementById("shop-modal").classList.add('display-disabled');
  } else {
    document.getElementById("shop-modal").classList.add('display-enabled');
    document.getElementById("shop-modal").classList.remove('display-disabled');
  }
}

function CloseModal() {
  if(!document.getElementById("shop-modal").classList.contains('display-disabled') && modalClick != true) {
    document.getElementById("shop-modal").classList.remove('display-enabled');
    document.getElementById("shop-modal").classList.add('display-disabled');
  }
  modalClick = false;
}

function ClickTest() {
  modalClick = true;
}

function FindLink() {
  let classes = document.getElementsByClassName("site-nav__link--main");
  
  for(let i = 0; i < classes.length; i++){

    if(classes[i].children[0].innerHTML == "Nettbutikk") {
      //classes[i].addEventListener("click", ToggleModal);

      if(!customer) {
        classes[i].href = "/account/login"
      }
    }
  }
}

function AddQuantity(amount) {
  let quantity = Number(event.target.parentNode.childNodes[3].value);
  quantity += Number(amount);

  event.target.parentNode.childNodes[3].value = quantity;
}
